import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login/login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/weixinLogin", // 微信登录回调地址
    name: "Weixin",
    component: () =>
      import(/* webpackChunkName: "Weixin" */ "../components/weixinData/weixinData.vue"),
  },
  {
    path: "/accountCenter",
    name: "AccountCenter",
    component: () =>
      import(/* webpackChunkName: "accountCenter" */ "../views/home/accountInfo.vue"),
  },
];

const router = new VueRouter({
  // base: '/saas/',
  routes,
});

export default router;
